import React from 'react';
import PropTypes from 'prop-types';

import { CustomInput, Container, Error } from './styles';

function Input({ id, value, type, placeholder, onChange, onBlur, error }) {
  return (
    <Container>
      <CustomInput
        id={id}
        name={id}
        value={value}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
      />
      <Error error={error}>{error}</Error>
    </Container>
  );
}

Input.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
};

Input.defaultProps = {
  id: '',
  value: '',
  type: '',
  placeholder: '',
  onChange: () => {},
  onBlur: () => {},
  error: '',
};

export default Input;
